import type { GTMEventReturnType } from '../GTM.types';
import GTMBaseModel from '../GTMBaseModel';

export default class GTMOverviewFilterRemoveAllModel extends GTMBaseModel {
    public static parseToGTMData(): GTMEventReturnType {
        return {
            ...GTMBaseModel.getBaseData(),
            ga4_property: 'cro_event',
            ga4_event_name: 'overview_filter_remove_all'
        };
    }
}
